import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { Link } from 'react-router-dom';
import { UncontrolledCollapse, Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { dateFormat } from '../../../../util/date';

import { getUnreadNotificationsRequest, getUnreadNotifications } from '../../NotificationActions';
import { getLoggedUser } from '../../../User/UserActions';

class NotificationSummary extends Component {
    componentDidMount() {
        this.fetchNotifications();
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.user !== this.props.user) {
            this.fetchNotifications();
        }
    }

    fetchNotifications = () => {
        if(this.props.user) {
            this.props.dispatch(getUnreadNotificationsRequest());
        }
    }

    renderNotification = notification => {
        switch(notification.targetType.toLowerCase()) {
            case 'institution':
            case 'user':
            case 'subject':
            case 'session':
            default: {
                const { target } = notification;
                return (
                    <Fragment>
                        <FormattedMessage id={notification.targetType.toLowerCase()} defaultMessage={notification.targetType} /> <small><em>{target.label || target.name || target.email}</em></small><br />
                        <Link to={`/${notification.targetType.toLowerCase()}/${target._id}#notifications-list`}>
                            <FontAwesomeIcon icon="eye" />
                        </Link>
                    </Fragment>
                );
            }
        }
    }

    render() {
        if(this.props.user && this.props.notifications.length) {
            return (
                <div className="position-relative">
                    <Link to="#" id="notifications-toggler" className="h5 text-danger"><FontAwesomeIcon icon="bell" /></Link>
                    <UncontrolledCollapse toggler="#notifications-toggler" className="position-absolute p-2 bg-primary rounded-sm" style={{ top: '100%', right: 0, minWidth: '20rem', zIndex: 10 }}>
                        {this.props.notifications.map(notification => (
                            <div key={notification._id} className="mb-1 pb-1 border-bottom text-end" style={{ fontSize: '0.8rem' }}>
                                {this.renderNotification(notification)}
                            </div>
                        ))}
                    </UncontrolledCollapse>
                </div>
            );
        }
        return null;
    }
}

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
        notifications: getUnreadNotifications(store),
    };
}

NotificationSummary.defaultProps = {
    user: null,
    notifications: [],
};

NotificationSummary.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    user: PropTypes.object,
    notifications: PropTypes.arrayOf(PropTypes.object),
};
export default connect(mapStateToProps)(withIntl(NotificationSummary));
